
export const fmtDate = v => {
  if (!v) return undefined
  const d = v instanceof Date ? v : new Date(v)
  if (Number.isNaN(d.getTime())) return undefined
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

export const base64ToBlob = b64 => {
  try {
    const bin = atob(b64)
    const u8 = new Uint8Array(bin.length)
    for (let i = 0; i < bin.length; i++) u8[i] = bin.charCodeAt(i)
    return new Blob([u8], { type: 'application/octet-stream' })
  } catch {
    return null
  }
}

export const toFileLike = f => {
  if (!f) return null
  if (f instanceof File) return f
  if (f.raw instanceof File) return f.raw
  if (f.file instanceof File) return f.file
  if (f.base64 && f.name) {
    const blob = base64ToBlob(f.base64)
    if (blob) return new File([blob], f.name)
  }
  return null
}

export const setByPath = (obj, path, value) => {
  if (!path) return value
  const keys = String(path).split('.')
  const next = Array.isArray(obj) ? [...obj] : { ...(obj || {}) }
  let cur = next
  for (let i = 0; i < keys.length - 1; i++) {
    const k = keys[i]
    const v = cur[k]
    cur[k] = Array.isArray(v) ? [...v] : { ...(v || {}) }
    cur = cur[k]
  }
  cur[keys[keys.length - 1]] = value
  return next
}

export const buildMultipart = ({
                                 json = {},
                                 jsonKey = 'request',
                                 jsonMetaPath,
                                 slotFiles,
                                 files,
                                 fileFieldName = 'files',
                                 mapSlotToMeta,
                                 mapFileToMeta
                               } = {}) => {
  const fd = new FormData()
  const meta = []

  if (slotFiles && typeof slotFiles === 'object' && !Array.isArray(slotFiles)) {
    Object.entries(slotFiles).forEach(([slot, f]) => {
      const file = toFileLike(f)
      if (!file) return
      const m = typeof mapSlotToMeta === 'function'
        ? mapSlotToMeta(slot, file)
        : { fileName: file.name, slot }
      meta.push(m)
      fd.append(fileFieldName, file, file.name)
    })
  }

  if (Array.isArray(files)) {
    files.forEach(item => {
      const file = toFileLike(item?.file || item) || null
      if (!file) return
      const m = item?.meta
        ? item.meta
        : typeof mapFileToMeta === 'function'
          ? mapFileToMeta(file)
          : { fileName: file.name }
      meta.push(m)
      fd.append(fileFieldName, file, file.name)
    })
  }

  const payload = jsonMetaPath ? setByPath(json, jsonMetaPath, meta) : json
  fd.append(jsonKey, new Blob([JSON.stringify(payload)], { type: 'application/json' }))
  return fd
}

export const appendFiles = (fd, files, fieldName = 'files') => {
  (files || []).forEach(f => {
    const file = toFileLike(f?.file || f)
    if (file) fd.append(fieldName, file, file.name)
  })
  return fd
}
